import React, { FunctionComponent, memo } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

interface SavingOverlayProps {
  open: boolean;
  testId?: string;
}

// Translucent white overlay used while a save is in flight. Matches the
// proportions and behavior of the initial-login spinner (`AppLoadingIndicator`)
// by reusing MUI defaults for `CircularProgress` (no size/color override).
// Z-index sits just below modal so existing dialogs continue to layer on top
// if one happens to be open when the save begins.
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    zIndex: theme.zIndex.modal - 1,
  },
}));

const SavingOverlay: FunctionComponent<SavingOverlayProps> = ({ open, testId = "saving-overlay" }) => {
  const classes = useStyles();

  if (!open) {
    return null;
  }

  return (
    <Backdrop open className={classes.root} data-testid={testId} aria-busy aria-live="polite">
      <CircularProgress data-testid={`${testId}-spinner`} />
    </Backdrop>
  );
};

export default memo(SavingOverlay);
